var _excluded = ["customStyle", "disabled", "icon"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { buttonAs } from '../../button';
import IconX from '../../icons/icon_x';
import propTypes from './prop_types';
import useStyles from './use_styles';
import { useTheme } from '@veneer/theme';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Button = buttonAs('div');
var UtilityButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      customStyle,
      disabled = false,
      icon = ___EmotionJSX(IconX, null)
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  var style = useStyles();
  var theme = useTheme();
  var isHc = theme.mode === 'contrast';
  return ___EmotionJSX(Button, _extends({}, other, {
    appearance: "ghost",
    customStyle: [style.root, isHc && style.hc, disabled && style.disabled, customStyle],
    disabled: disabled,
    leadingIcon: icon,
    ref: ref,
    role: "button",
    "aria-hidden": true,
    small: true
  }));
});
UtilityButton.propTypes = propTypes;
UtilityButton.displayName = 'UtilityButton';
export default UtilityButton;